<template>
  <detailMerchantPage :param="param" v-if="param.app=='MP'" />
  <detailCryptoPage :param="param" v-else-if="param.app=='CR'" />
  <detailChargebackPage :param="param" v-else-if="param.app=='CS'" />
  <detailEcheckPage :param="param" v-else-if="param.app=='EC'" />
</template>

<script>
import {
  detailChargebackPage,
  detailCryptoPage,
  detailEcheckPage,
  detailMerchantPage
} from "./detailpages/baseDetailPages";
export default {
  components: {
    detailChargebackPage,
    detailCryptoPage,
    detailEcheckPage,
    detailMerchantPage
  },
  data: () => {
    return {
      param: {
        key: null,
        app: null
      }
    };
  },
  created() {
    this.param = this.$route.params;
  }
};
</script>

<style>
</style>